import ReactECharts from "echarts-for-react";
import { useState, useEffect } from "react";
import "../../../../cssfiles/homepage.css";
import { useSelector, useDspatch } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";

const DeviceDonut = (props) => {
  const theme = useSelector((state) => state.themedata.theme);

  const tagcollectionvalue = useSelector(
    (state) => state.mainpagedata.tagcollectionvalues
  );

  const sdate_edate_selected = useSelector(
    (state) => state.mainpagedata.selecteddates
  );

  const devicedetailsobject = useSelector(
    (state) => state.mainpagedata.devicedetailsobject
  );

  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );
  const devices = useSelector((state) => state.diagnosticdata.deviceList);

  const [loading, setLoading] = useState(true);

  var tag_properties = props.widgetprop.props.extended.tagprops;
  var color_properties_donuts = [];
  var tagname_properties_donuts = [];
  const color_map = new Map();

  tag_properties.map((charttype) => {
    color_properties_donuts.push(charttype.chartprops.color);
    tagname_properties_donuts.push(charttype.tagname);
    color_map.set(charttype.tagname, charttype.chartprops.color);
  });

  const [option, setOption] = useState({});

  useEffect(() => {
    const tag_properties = props.widgetprop.props.extended.tagprops;
    const color_map = new Map();
    const data = [];
    var connected = 0;
    var disconnected = 0;

    for (var i = 0; i < devices.length; i++) {
      if (devices[i][2] === "Connected") {
        connected++;
      } else if (devices[i][2] === "Disconnected") {
        disconnected++;
      }
    }

    tag_properties.forEach((charttype) => {
      color_map.set(charttype.displayname, charttype.chartprops.color);

      color_map.set(charttype.tagname, charttype.chartprops.color);

      data.push(disconnected);
      data.push(connected);
    });

    const donutchartbasedoptions = {
      title: {
        text: "",
        subtext: "",
        top: "110px",
        left: "90px",
        paddingTop: "13px",
        textStyle: {
          fontSize: props.widgetprop.props.extended.textname.fontsize,
          fontWeight: props.widgetprop.props.extended.textname.fontweight,
          fontFamily: props.widgetprop.props.extended.textname.fontfamily,
          align: "center",
          color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
        },
        subtextStyle: {
          fontSize: props.widgetprop.props.extended.textvalue.fontsize,
          fontWeight: props.widgetprop.props.extended.textvalue.fontweight,
          fontFamily: props.widgetprop.props.extended.textvalue.fontfamily,
          color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
          align: "center",
        },
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["70%", "80%"],
          itemStyle: {
            borderColor: theme === "light" ? "#FFFFFF" : "#000000",
            borderWidth: 3,
          },
          emphasis: {
            scaleSize: 0,
          },
          label: {
            position: "inside",
            formatter: "{d}%",
            color: theme === "light" ? "#000000" : "#FFFFFF",
            fontSize: "10px",
            fontWeight: 700,
            fontFamily: "Roboto",
          },
          data: tag_properties.map((charttype, index) => ({
            value: Number(data[index]),
            name:
              charttype.config.type_of_config == "timedurationwise_calculation"
                ? charttype.displayname
                : charttype.tagname,
            itemStyle: {
              color:
                charttype.config.type_of_config ==
                "timedurationwise_calculation"
                  ? color_map.get(charttype.displayname)
                  : color_map.get(charttype.tagname),
            },
            label: { show: false },
          })),
        },
        {
          name: "",
          type: "pie",
          radius: [0, "70%"],
          itemStyle: {
            borderColor: theme === "light" ? "#FFFFFF" : "#000000",
            borderWidth: 3,
          },
          emphasis: {
            scaleSize: 0,
          },
          label: {
            position: "inside",
            formatter: "{c}",
            color: "#FFFFFF",
          },
          data: tag_properties.map((charttype, index) => ({
            value: Number(data[index]),
            name:
              charttype.config.type_of_config == "timedurationwise_calculation"
                ? charttype.displayname
                : charttype.tagname,
            itemStyle: {
              color:
                theme === "light"
                  ? charttype.chartprops.color_inner_light
                  : charttype.chartprops.color_inner_dark,
            },
            label: {
              show: true,
              color: theme === "light" ? "#000000" : "#FFFFFF",
            },
          })),
        },
      ],
      legend: {
        left: "250px",
        top: "40px",
        borderColor: "var(--PrimaryBackground)",
        paddingTop: 20,
        paddingLeft: 10,
        paddingRight: 2,
        itemGap: 30,
        itemStyle: {
          color: "inherit",
          borderColor: "",
          borderWidth: 0,
        },
        textStyle: {
          color: theme === "light" ? "#000000" : "#FFFFFF",
        },
        data: tag_properties
          .map((charttype, index) => ({
            value: data[index],
            name:
              charttype.config.type_of_config == "timedurationwise_calculation"
                ? charttype.displayname
                : charttype.tagname,
            itemStyle: {
              color:
                charttype.config.type_of_config ==
                "timedurationwise_calculation"
                  ? color_map.get(charttype.displayname)
                  : color_map.get(charttype.tagname),
            },
            label: { show: false },
          }))
          .map((data_object) => ({ name: data_object.name, icon: "circle" })),
        z: 4,
        orient: "vertical",
      },
      tooltip: {
        trigger: "item",
        backgroundColor: "#005C8E",
        borderColor: "#000000",
        borderRadius: [0, 0, 0, 8],
        borderWidth: 0,
        renderMode: "html",
        extraCssText: "border-radius: 0 0 0 8px",
        textStyle: {
          color: "#FFFFFF",
          fontSize: 12,
          height: 3,
          fontFamily: "Roboto",
          padding: 0,
        },
        formatter: function (params) {
          let stringconst;
          tag_properties.forEach((charttype) => {
            if (
              charttype.config.type_of_config == "timedurationwise_calculation"
            ) {
              if (params.data.name === charttype.displayname) {
                stringconst = `<div style="display:flex; flex-direction:row "><div style="border-radius:10px; margin-top:4px; margin-right:5px; height:10px; width:10px; background-color:${color_map.get(
                  charttype.displayname
                )}"></div>${params.data.name}:${params.data.value}</div>`;
              }
            } else {
              if (params.data.name === charttype.tagname) {
                stringconst = `<div style="display:flex; flex-direction:row "><div style="border-radius:10px; margin-top:4px; margin-right:5px; height:10px; width:10px; background-color:${color_map.get(
                  charttype.tagname
                )}"></div>${params.data.name}:${params.data.value}</div>`;
              }
            }
          });
          return stringconst;
        },
      },
      grid: {
        left: -50,
        top: 30,
        containLabel: true,
      },
      height: 250,
      width: 230,
    };

    setOption(donutchartbasedoptions);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [props.widgetprop, theme, tagcollectionvalue, devices]);

  return (
    <>
      <div
        style={{
          display: "inline-flex",
          flexDirection: "row",
          width: "100%",
          height: "100%",
        }}
      >
        {loading && (
          <CircularProgress sx={{ marginTop: "100px", marginLeft: "200px" }} />
        )}
        {!loading && (
          <ReactECharts
            option={option}
            style={{ height: "95%", width: "140%" }}
          />
        )}
      </div>
    </>
  );
};

export default DeviceDonut;
